import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { N500A } from '@atlaskit/theme/colors';
import { PartnerPromotionItem } from '@css-xp/base/partner-promotion-item';
import { getPromotionTitle, renderPromotionValue } from '@css-xp/base';

import { PartnerPromotionType } from '../subscription-txa-transfer-pane';
import { EntitlementDetails, Promotion } from '@css-xp/graphtypes/src/generated-types-new';
import { PARTNER_DISCOUNT } from '@atlassian/cssxp-utils-entitlement';

type Props = {
  entitlement: EntitlementDetails;
  partnerPromotionData?: PartnerPromotionType;
};

const RemovePartnerDiscountBox = ({ partnerPromotion }: { partnerPromotion: Promotion }) => (
  <div className="remove-partner-promotion">
    <strong>{getPromotionTitle(partnerPromotion, { handleEmptyTitle: true })}</strong>
    <p className="remove-partner-promotion-details">
      {renderPromotionValue(partnerPromotion, { showDuration: true, showReason: true })}
    </p>
  </div>
);

export const PartnerDiscountSection = ({ entitlement, partnerPromotionData }: Props) => {
  const activePartnerPromotion = (entitlement?.promotions ?? []).find(
    (promotion) => promotion?.type === PARTNER_DISCOUNT
  );
  const scheduledPartnerPromotion = (entitlement?.scheduledChanges?.promotions ?? []).find(
    (promotion) => promotion?.type === PARTNER_DISCOUNT
  );

  if (partnerPromotionData?.response || activePartnerPromotion || scheduledPartnerPromotion) {
    return (
      <div className="plan-view mt-40 partner-discount-section" data-testid="partner-discount-form">
        <h2>Partner discount</h2>
        {activePartnerPromotion && (
          <div>
            <h3>
              <span className="partner-promotion-header">Current discount</span>
            </h3>
            <div data-testid="activePartnerPromotionBox">
              <RemovePartnerDiscountBox partnerPromotion={activePartnerPromotion} />
            </div>
          </div>
        )}
        {scheduledPartnerPromotion && (
          <div>
            <h3>
              <span className="partner-promotion-header">Discount to be applied to next bill</span>
            </h3>
            <div data-testid="scheduledPartnerPromotionBox">
              <RemovePartnerDiscountBox partnerPromotion={scheduledPartnerPromotion} />
            </div>
          </div>
        )}
        {partnerPromotionData?.response && (
          <div>
            <h3>
              <span className="partner-promotion-header">Automatic discount</span>
              <Tooltip
                content="The account receiving the transfer is eligible for an automatic discount"
                tag="span"
                position="right"
                truncate
              >
                <InfoIcon size="small" testId="info-icon" label="Info" primaryColor={N500A} />
              </Tooltip>
            </h3>
            <div data-testid="partnerPromotionBox">
              <PartnerPromotionItem
                partnerPromotion={partnerPromotionData.response}
                isRemovePromotionHidden
                isPromotionReasonHidden
              />
            </div>
          </div>
        )}
      </div>
    );
  }
  return null;
};
